import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { useSelector } from 'react-redux';
import { ENTITIES } from 'src/models/QuerybuilderModel';

const DeleteFundraisingButton = (props: ButtonProps) => {
  const { disabled } = props;
  const dispatch = useAppDispatch();

  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.fundraisings] || [],
  );

  const handleOpen = () => {
    dispatch(openDialog(
      { dialog: DIALOGS.deleteFundraising, payload: { fundraisingId: selections[0] } },
    ));
  };

  return (
    <>
      <Tooltip
        title="Delete Fundraising"
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={disabled || selections.length > 1}>
            <DeleteIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default DeleteFundraisingButton;
